/*
 * @Description: 社保公积金
 */
export default [
  {
    name: 'schemeConfigurationList',
    path: '/socialSecurityAndHousingFund/schemeConfiguration/list',
    component: () =>
      import('@/views/socialSecurityAndHousingFund/schemeConfiguration/list.vue'),
    meta: {
      title: '方案配置'
    }
  },
  {
    name: 'socialSecurityRecordsList',
    path: '/socialSecurityAndHousingFund/socialSecurityRecords/list',
    component: () => import('@/views/socialSecurityAndHousingFund/socialSecurityRecords/list.vue'),
    meta: {
      title: '社保档案',
      replaceSameTab: true,
    },
    props: (route) => ({
      pageKey: route.query.pageKey,
    })
  },
  {
    name: 'providentFundArchives',
    path: '/socialSecurityAndHousingFund/providentFundArchives',
    component: () => import('@/views/socialSecurityAndHousingFund/providentFundArchives/index.vue'),
    meta: {
      title: '公积金档案',
      replaceSameTab: true,
    },
    props: (route) => ({
      pageKey: route.query.pageKey,
    })
  },
  {
    name: 'monthlyAccounting',
    path: '/socialSecurityAndHousingFund/monthlyAccounting',
    component: () => import('@/views/socialSecurityAndHousingFund/monthlyAccounting/index.vue'),
    meta: {
      title: '月度核算'
    }
  },
  {
    name: 'socialSecurityAccountDetail',
    path: '/socialSecurityAndHousingFund/monthlyAccounting/socialSecurityAccountDetail/:id',
    component: () => import('@/views/socialSecurityAndHousingFund/monthlyAccounting/socialSecurityAccountDetail.vue'),
    meta: {
      title: '社保核算详情页',
      parentAuth: "/socialSecurityAndHousingFund/monthlyAccounting",
    }
  },
  {
    name: 'housingFundAccountDetail',
    path: '/socialSecurityAndHousingFund/monthlyAccounting/housingFundAccountDetail/:id',
    component: () => import('@/views/socialSecurityAndHousingFund/monthlyAccounting/housingFundAccountDetail.vue'),
    meta: {
      title: '公积金核算详情页',
      parentAuth: "/socialSecurityAndHousingFund/monthlyAccounting",
    }
  },
  {
    name: 'salaryAllocation',
    path: '/socialSecurityAndHousingFund/salaryAllocation',
    component: () => import('@/views/socialSecurityAndHousingFund/salaryAllocation/index.vue'),
    meta: {
      title: '薪酬配置'
    }
  },
  {
    name: 'paymentDetails',
    path: '/socialSecurityAndHousingFund/paymentDetails',
    component: () => import('@/views/socialSecurityAndHousingFund/paymentDetails/index.vue'),
    meta: {
      title: '缴纳明细'
    }
  },
  {
    name: 'costDetails',
    path: '/socialSecurityAndHousingFund/costDetails',
    component: () => import('@/views/socialSecurityAndHousingFund/costDetails/index.vue'),
    meta: {
      title: '费用明细'
    }
  },
];
